import styled, { css } from 'styled-components';

export const UploadModalStyle = styled.div`
  width: 100%;
  position: relative;
  font-size: 16px;
  line-height: 20px;
  color: var(--text-color);

  .holder {
    display: flex;
    gap: 10px;
    justify-content: space-between;
  }

  .title {
    display: block;
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
    color: var(--text-color);
    margin: 0 0 5px;
  }

  .left-col {
    flex-shrink: 0;
    width: 150px;
  }
  .upload-col {
    flex-grow: 1;
    overflow: auto;
    max-height: 600px;
    padding: 0 5px 0 0;
  }
  .right-col {
    position: relative;
    flex-shrink: 0;
    width: 250px;
    border-left: 1px solid #cdcdcd;
    padding: 0 0 33px 10px;

    .subtitle {
      display: block;
      margin: 0 0 10px;
    }

    .search-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #cdcdcd;
      padding: 10px 0;
      margin: 0 0 10px;

      .text-box {
        display: flex;
        align-items: center;
        gap: 6px;

        .icon {
          flex-shrink: 0;
          font-size: 20px;
          line-height: 1;
          color: var(--text-color);
        }
        .text {
          display: block;
          color: var(--text-color);
        }
      }

      .btn {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 36px;
        border-radius: 10px;
        background: rgba(26, 42, 108, 0.1);

        &.checked {
          .text-on {
            display: block;
          }
          .text-off {
            display: none;
          }
        }

        .text-on {
          display: none;
        }
        .text-off {
          display: block;
        }
      }
    }

    .col-footer {
      position: absolute;
      left: 10px;
      right: 0;
      bottom: 5px;
      display: flex;
      align-items: center;
      flex-flow: wrap;
      justify-content: space-between;
      gap: 10px;
    }
  }

  .uploaded-file-list {
    list-style: none;
    margin: 0;
    padding: 0;
    color: var(--text-color);
    font-size: 13px;
    line-height: 16px;

    li {
      position: relative;
      padding: 4px 18px 2px 4px;
      border-radius: 4px;
      margin-bottom: 2px;
      transition: 0.3s all ease-in-out;
      &:hover {
        background: #721b1f;
      }
      .btn-delete {
        position: absolute;
        top: 1px;
        right: -2px;
        font-size: 20px;
        line-height: 1;
        color: var(--text-color);

        &:hover {
          color: var(--text-color);
        }
      }
    }

    .file-name {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .file-size {
      display: block;
      color: var(--text-color);
    }
  }
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 17px;
    height: 17px;
    border-radius: 50%;
    display: inline-block;
    border-top: 3px solid #333;
    border-right: 3px solid transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    ${({ $lg }) =>
      $lg &&
      css`
        width: 27px;
        height: 27px;
      `}

    @keyframes rotation {
      0% {
        transform: translate(-50%, -50%) rotate(0deg);
      }
      100% {
        transform: translate(-50%, -50%) rotate(360deg);
      }
    }
  }
  .drop-holder {
    width: 100%;
    min-height: 150px;
    padding: 25px 15px 15px;
    border-radius: 15px;
    border: 1px dashed #9d9d9d;

    .title {
      display: block;
      text-align: center;
      margin: 0 0 15px;
    }

    .wrap {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 10px;
      width: 100%;

      .upload-box {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        flex-grow: 1;
        height: 150px;
        padding: 10px;
        font-size: 14px;
        line-height: 17px;
        border: 1px solid rgba(157, 157, 157, 0.3);
        border-radius: 12px;

        input {
          display: none;
        }
      }
    }
  }

  .link-list {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 16px;
    line-height: 20px;

    li {
      margin: 0 0 10px;

      a {
        display: flex;
        align-items: center;
        gap: 5px;
        color: var(--text-color);

        &:hover {
          color: var(--text-color);
        }
      }
    }
  }

  .content-box {
    width: 100%;
    padding: 15px;
    margin: 0 0 12px;
    position: relative;
    border-radius: 15px;
    border: 1px solid #cdcdcd;

    &.active {
      .search-area {
        display: block;
      }
    }

    .text {
      display: block;
      font-size: 14px;
      line-height: 18px;
      padding-top: 5px;
    }

    .input-holder {
      display: flex;
      align-items: end;
      gap: 10px;
    }

    .btn-add {
      width: 50px;
      height: 50px;
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
    }

    .search-area {
      width: 100%;
      display: none;
    }

    .text-area {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 0 20px;

      .title {
        margin: 0 0 5px;
      }

      .btn-check {
        position: relative;
        width: 45px;
        height: 26px;
        cursor: pointer;
        border-radius: 50px;
        background: #ccc;

        &.checked {
          background: var(--text-color);

          &::before {
            left: 21px;
          }
        }

        &::before {
          content: '';
          position: absolute;
          top: 2px;
          left: 2px;
          width: 22px;
          height: 22px;
          transition: all ease-in-out 0.3s;
          border-radius: 50px;
          background: #e8f5e9;
        }
      }
    }

    .textarea-holder {
      width: 100%;

      label {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        margin: 0 0 5px;
      }
      textarea {
        width: 100%;
        height: 150px;
        padding: 15px;
        border: 1px solid rgba(157, 157, 157, 0.6);
        border-radius: 15px;
        background: transparent;
        outline: none;
      }
    }
  }

  .btn-holder {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 15px;
    border-top: 1px solid #cdcdcd;
  }
`;
